var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67488 10.4999C1.67488 9.80142 2.24112 9.23518 2.93962 9.23518H17.5601C18.2586 9.23518 18.8248 9.80142 18.8248 10.4999C18.8248 11.1984 18.2586 11.7647 17.5601 11.7647H2.93962C2.24112 11.7647 1.67488 11.1984 1.67488 10.4999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67488 14.9987C1.67488 14.3002 2.24112 13.7339 2.93962 13.7339H17.5601C18.2586 13.7339 18.8248 14.3002 18.8248 14.9987C18.8248 15.6971 18.2586 16.2634 17.5601 16.2634H2.93962C2.24112 16.2634 1.67488 15.6971 1.67488 14.9987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67488 6.00119C1.67488 5.30269 2.24112 4.73645 2.93962 4.73645H17.5601C18.2586 4.73645 18.8248 5.30269 18.8248 6.00119C18.8248 6.69968 18.2586 7.26593 17.5601 7.26593H2.93962C2.24112 7.26593 1.67488 6.69968 1.67488 6.00119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.5577a48b469dea760a00d79d3a348e63.svg";
export { ForwardRef as ReactComponent };